import React from 'react';
import { CHAPTERS, chapterLabel } from '../data/script';
export function ChapterCard({
  chapter
}: {
  chapter: number;
}) {
  return <div key={chapter} className="pointer-events-none absolute inset-x-0 top-[15%] z-20 flex justify-center px-6 animate-[chapterCard_2.6s_ease_both]" data-id="element-112" data-mp="1hexr18joowht">
      <div className="text-center" data-id="element-113" data-mp="17ouoohqoa66t">
        <div className="font-mono text-[13px] tracking-[0.3em] text-[#9A9FB0]" data-id="element-114" data-mp="17ntc28u0dbmz">
          CHAPTER {chapterLabel(chapter)}
        </div>
        <div className="mt-2 text-[34px] font-semibold leading-10 tracking-[-0.02em] text-[#EDEEF2] max-sm:text-[26px] max-sm:leading-8" data-id="element-115" data-mp="yoy2cmrr9jex">
          {CHAPTERS[chapter].title}
        </div>
      </div>
    </div>;
}